export function SectionHeading() {
  return (
    <div className="text-center lg:text-left">
      <h2
        id="contact-heading"
        className="mb-4 text-2xl font-semibold text-foreground sm:text-3xl"
      >
        Contact
      </h2>
      <p className="mx-auto max-w-xl text-base leading-7 text-muted-foreground lg:mx-0">
        Share a little about the role, product, or project and I will get back
        to you soon.
      </p>
    </div>
  );
}
